import { Box, Button, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"
import { PropsLeft } from "./types"
import { DinamicForm } from "../../../../../../../../../../components/dinamicForm"
import { DateModalSimple } from "../../../../../../../../../../components/dinamicForm/dateModal"
import { useEffect, useMemo, useState } from "react"
import dayjs from "dayjs"
import { DestinationType } from "../../enums/destinationType"
import { generalDisabled } from "../../../../../../../../../../utils/validate/validate"
import { InputModal } from "../inputModal"
import { CustomTable, SnackSimple } from "../../../../../../../../../../components"
import { CustomeIconButton } from "../../../../../../../../../../components/customeIconButton"
import { icons } from "../../../../../../../../../../utils/icons"
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { toUnitTimeZone } from "../../../../../../../../../../utils/methods/calcDate"
import { MapActivity } from "../../../../../mapActivity"
import { getLocalStorage } from "../../../../../../../../../../utils/crud/crypt"
import { Destination, Local } from "../../types"
import { Roles, Types } from "../../../../../../../../../../utils/enums"
import { PopoverButtons } from "../../../../../../../../../../components/buttons/popoverButtons"
import SimpleModal from "../../../../../../../../../../components/modal/simpleModal"
import { DestinationModal } from "../destinationModal"


export const LeftActivityForm = (props: PropsLeft) => {

    dayjs.extend(utc);
    dayjs.extend(timezone);

    const styles = useStyles()
    const { t } = useTranslation()
    const [openUnityModal, setOpenUnityModal] = useState(false)
    const [openDestinatioModal, setOpenDestinatioModal] = useState(false)
    const [openDestinatioModalRegitred, setOpenDestinatioModalRegistred] = useState(false)
    const [openSimple, setOpenSimple] = useState<{
        open: boolean
        title: string
        description: string
        confirm: () => void
        cancel?: () => void
    }>({
        open: false,
        title: '',
        description: '',
        confirm: () => { }
    })

    const [openSnackbar, setOpenSnackbar] = useState({ open: false, type: Types.SUCCESS, message: '' })
    const allDestionatiosList = [
        ...props.destinatioCreated,
        /* ...props.localRegister.map(item => ({
            name: item.name,
            creator: item.creator,
            direction: item.direction,
            latitude: item.latitude,
            longitude: item.longitude,
            id: item.id
        })) */
    ]


    const disableActivityForm = useMemo(() => generalDisabled(props.inputActivity, props.dataActivity), [props.dataActivity, props.inputActivity])
    //const disableDestinationForm = useMemo(() => generalDisabled(props.inputDestination, props.dataDestination), [props.dataDestination])
    const [editInEdit, setEditInEdit] = useState<boolean>(false)
    const [errors, setErrors] = useState<Record<string, string>>({})
    const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [oldTypeDestination, setOldTypeDestination] = useState<DestinationType>()
    const [destinationFinalCopy, setDestinationFinalCopy] = useState<Destination | undefined>(undefined)
    const [value, setValue] = useState<{ name: string, direction: string, company?: { label: string, value: number } }>({ name: '', direction: '', company: undefined })
    const company: Local = getLocalStorage()
    const [id, setId] = useState<number>()

    const handleAddActivity = () => {
        props.handleActivities({
            id: String(Math.floor(Math.random() * 1000) + 1),
            error: false,
            open: props.dataActivity?.open ? String(props.dataActivity.open) : undefined,
            name: props.dataActivity?.title ? String(props.dataActivity.title) : null,
            type: props.dataActivity?.typeOfActivity ? {
                label: String((props.dataActivity.typeOfActivity.label)),
                value: String((props.dataActivity.typeOfActivity.value)),
                openField: (props.dataActivity.typeOfActivity.openField)
            } : null,
            startDate: props.dataActivity?.to ? dayjs(props.dataActivity?.from) : undefined,
            endDate: props.dataActivity?.to ? dayjs(props.dataActivity?.to) : undefined,
            destination: {
                id: props.destinationFinal?.id ? Number(props.destinationFinal?.id) : null,
                latitude: Number(props.destinationFinal?.latitude ?? 0),
                longitude: Number(props.destinationFinal?.longitude ?? 0),
                name: String(props.destinationFinal?.name ?? ''),
                type: props.destinationFinal?.type ?? DestinationType.DESTINATION,
                timeZone: props.destinationFinal?.timeZone,
                companyName: props.destinationFinal?.companyName,
                compnayId: props.destinationFinal?.compnayId,
                direction: props.destinationFinal?.direction,
                idDestnation: props.destinationFinal?.idDestnation,
                toCreate: props.destinationFinal?.toCreate,
                toCreateSelected: props.destinationFinal?.toCreateSelected
            },
            free: !!props.dataActivity?.free
        })
        if (Boolean(value.name) && props.destinationFinal?.toCreate) {
            props.setLocalRegister(prev => [
                ...prev,
                {
                    companyName: value.company?.label,
                    companyId: value.company?.value,
                    creator: company.fullName,
                    direction: value.direction,
                    id: id ? id : 0,
                    name: value.name,
                    latitude: props.selectedPoint?.lat ?? 0,
                    longitude: props.selectedPoint?.lng ?? 0,
                }
            ]);
        }
        props.handleDataActivity()
        props.handleChangeCrud({ name: 'from', date: dayjs() })
        props.setDefaultValues({ from: dayjs(), to: null })
        props.setDestinationFinal(undefined)
    }

    const handleEditActivity = () => {
        setEditInEdit(false)
        props.editActivity(
            {
                id: String(Math.floor(Math.random() * 1000) + 1),
                error: false,
                open: props.dataActivity?.open ? String(props.dataActivity.open) : undefined,
                name: props.dataActivity?.title ? String(props.dataActivity.title) : null,
                type: props.dataActivity?.typeOfActivity ? {
                    label: String((props.dataActivity.typeOfActivity.label)),
                    value: String((props.dataActivity.typeOfActivity.value)),
                    openField: (props.dataActivity.typeOfActivity.openField)
                } : null,
                startDate: props.dataActivity?.to ? dayjs(props.dataActivity?.from) : undefined,
                endDate: props.dataActivity?.to ? dayjs(props.dataActivity?.to) : undefined,
                destination: {
                    id: props.destinationFinal?.id ? Number(props.destinationFinal?.id) : null,
                    latitude: Number(props.destinationFinal?.latitude ?? 0),
                    longitude: Number(props.destinationFinal?.longitude ?? 0),
                    name: String(props.destinationFinal?.name ?? ''),
                    type: props.destinationFinal?.type ?? DestinationType.DESTINATION,
                    timeZone: props.destinationFinal?.timeZone,
                    companyName: props.destinationFinal?.companyName,
                    compnayId: props.destinationFinal?.compnayId,
                    direction: props.destinationFinal?.direction,
                    idDestnation: props.destinationFinal?.idDestnation,
                    toCreate: props.destinationFinal?.toCreate,
                    toCreateSelected: props.destinationFinal?.toCreateSelected
                },
                free: !!props.dataActivity?.free
            },
            String(props.idToEdit)
        )
        if (props.destinationFinal?.toCreate) {
            props.setLocalRegister((prev) =>
                prev.map((destinaiton) =>
                    destinaiton.id === props.destinationFinal?.idDestnation ?
                        {
                            ...destinaiton,
                            companyName: props.destinationFinal.companyName,
                            companyId: props.destinationFinal.compnayId,
                            direction: props.destinationFinal.direction ?? '',
                            name: props.destinationFinal.name,
                            latitude: props.destinationFinal.latitude,
                            longitude: props.destinationFinal.longitude,
                        } : destinaiton
                )
            );


        }
        props.handleDataActivity()
        props.handleChangeCrud({ name: 'from', date: dayjs() })
        props.setDefaultValues({ from: dayjs(), to: null })
        props.setIdToEdit(0)
        props.setDestinationFinal(undefined)
    }

    const closeModal = () => {
        setOpenUnityModal(false)
        setOpenDestinatioModal(false)
        setOpenDestinatioModalRegistred(false)
        props.filterUnity.cleanFilter()
    }

    const closeSimpleModal = () => {
        setOpenSimple(prev => ({ ...prev, open: false }))
    }

    const handleCloseSnackbar = () => {
        setOpenSnackbar((prev) => ({
            ...prev,
            open: false,
        }))
    }

    const handleCloseUnity = () => {
        closeModal()
        props.setUnityToDestination()
        /* setOldTypeDestination(DestinationType.UNITY) */
    }

    const handleCancelUnity = () => {
        closeModal()
        props.setDestinationFinal(destinationFinalCopy)
    }

    const handleEditUnity = (create: boolean) => {
        setOpenUnityModal(true);
        if (create) {
            props.setDestination(undefined)
            setDestinationFinalCopy(props.destinationFinal)
            props.setDestinationFinal(undefined)
        } else {
            props.setDestination(props.destinationFinal)
            setDestinationFinalCopy(props.destinationFinal)
        }

        props.filterUnity.cleanFilter()
        if (company.role !== Roles.ADMIN) {
            props.filterUnity.onChange({ target: { name: 'onlyHierarchy', value: true } })
        }
        setOldTypeDestination(DestinationType.DESTINATION)
    }

    const handleMapClick = (lat: number, lng: number) => {
        props.setSelectedPoint({ lat, lng });
    };

    const handlePlaceSelect = (place: google.maps.places.PlaceResult | null) => {
        if (place?.geometry?.location) {
            props.setSelectedPoint({ lat: place.geometry.location.lat(), lng: place.geometry.location.lng() });
        }
    };

    const handleSetDestination = ({ edit }: { edit: boolean }) => {
        closeModal()
        if (!edit) {
            setOpenSimple(prev => ({ ...prev, description: t('loogbook.modal.areYouSureYouWantToRegisterThisDestination'), title: t('loogbook.modal.doYouWantToRegisterTheDestination'), open: true, cancel: handleNotSetDestination, confirm: handleToCreateDestination }))
        } else {
            handleToEditDestination()
        }
    }

    const handleToCreateDestination = () => {
        const localId = Date.now()
        setId(localId)
        closeSimpleModal()
        const hasDuplicity = props.localRegister.some(item => {
            const sameLat = item.latitude === props.selectedPoint?.lat;
            const sameLng = item.longitude === props.selectedPoint?.lng;

            //if (company.company) {
            return false/* sameLat && sameLng */;
            //}

            /* return ( sameLat && sameLng && company.role === Roles.ADMIN && item.companyId === value.company?.value ); */
        });

        if (hasDuplicity) {
            setOpenDestinatioModal(true);
            setOpenSnackbar((prev) => ({
                ...prev,
                open: true,
                message: t('loogbook.snackbar.destionationAlreadyRegistered'),
                type: Types.ERROR
            }))
        } else {
            props.setDestinationFinal({
                id: null,
                latitude: props.selectedPoint?.lat ?? 0,
                longitude: props.selectedPoint?.lng ?? 0,
                name: value.name,
                compnayId: value.company?.value,
                direction: value.direction,
                type: DestinationType.DESTINATION,
                companyName: value.company?.label,
                idDestnation: localId,
                toCreate: true,
                toCreateSelected: false
            })
        }

    }

    const handleToEditDestination = () => {
        closeSimpleModal();
        //validar que no exista-coordenadas

        const hasDuplicity = props.localRegister.some(item => {
            if (item.id === props.destinationFinal?.idDestnation) return false;

            const sameLat = item.latitude === props.selectedPoint?.lat;
            const sameLng = item.longitude === props.selectedPoint?.lng;

            //if (company.company) {
            return false/* sameLat && sameLng; */
            //}
        });

        if (hasDuplicity) {
            setOpenDestinatioModal(true);
            setOpenSnackbar((prev) => ({
                ...prev,
                open: true,
                message: t('loogbook.snackbar.destionationAlreadyRegistered'),
                type: Types.ERROR
            }))
        } else {
            props.setDestinationFinal(prev => ({
                ...prev,
                id: null,
                latitude: props.selectedPoint?.lat ?? 0,
                longitude: props.selectedPoint?.lng ?? 0,
                name: value.name,
                compnayId: value.company?.value,
                direction: value.direction,
                type: DestinationType.DESTINATION,
                companyName: value.company?.label,
                toCreate: true,
                toCreateSelected: false
            }))
            props.setLocalRegister(prev =>
                prev.map(item =>
                    item.id === props.destinationFinal?.idDestnation
                        ? {
                            ...item,
                            companyName: value.company?.label,
                            companyId: value.company?.value,
                            direction: value.direction,
                            name: value.name,
                            latitude: props.selectedPoint?.lat ?? 0,
                            longitude: props.selectedPoint?.lng ?? 0,
                        }
                        : item
                )
            );
            /* props.editActivityDestination({
                destinationId: props.destinationFinal?.idDestnation ?? 0,
                data: {
                    id: null,
                    latitude: props.selectedPoint?.lat ?? 0,
                    longitude: props.selectedPoint?.lng ?? 0,
                    name: value.name,
                    compnayId: value.company?.value,
                    direction: value.direction,
                    type: DestinationType.DESTINATION,
                    companyName: value.company?.label,
                    toCreate: true,
                    toCreateSelected: false,
                    idDestnation: props.destinationFinal?.idDestnation,
                }
            }) */
        }

    }

    const handleNotSetDestination = () => {
        props.setDestinationFinal({
            id: null,
            latitude: props.selectedPoint?.lat ?? 0,
            longitude: props.selectedPoint?.lng ?? 0,
            name: value.name,
            compnayId: value.company?.value,
            direction: value.direction,
            type: DestinationType.DESTINATION,
            companyName: value.company?.label,
            idDestnation: undefined,
            toCreate: false,
            toCreateSelected: false
        })
        closeSimpleModal()
    }

    const handleSetDestinationSelected = ({ id, latitude, longitude, name, direction }: { direction: string, name: string, id?: number | null, latitude: number, longitude: number }) => {
        props.setDestinationFinal({
            id: null,
            latitude: latitude,
            longitude: longitude,
            name: name,
            compnayId: undefined,
            direction: direction,
            type: DestinationType.DESTINATION,
            companyName: undefined,
            idDestnation: id,
            toCreate: false,
            toCreateSelected: true
        })
        closeModal()
    }

    const handleEditDestination = (create: boolean) => {
        setOpenDestinatioModal(true);

        /* props.setDestination(undefined) */
        if (create) {
            setOldTypeDestination(DestinationType.UNITY)
            //props.handleDataDestination({})
            setValue({ name: '', direction: '', company: undefined })
            props.setSelectedPoint(null)
        } else {
            setOldTypeDestination(DestinationType.DESTINATION)
            setValue({ name: props.destinationFinal?.name ?? '', direction: props.destinationFinal?.direction ?? '', company: (props.destinationFinal?.companyName && props.destinationFinal.compnayId) ? { label: props.destinationFinal?.companyName, value: props.destinationFinal?.compnayId } : undefined })
        }
    }

    const handleEditDestinationSelected = (create: boolean) => {
        setOpenDestinatioModalRegistred(true);

        if (create) {
            setDestinationFinalCopy(props.destinationFinal)
            setOldTypeDestination(DestinationType.UNITY)
            props.setDestinationFinal(undefined)
        } else {
            setOldTypeDestination(DestinationType.DESTINATION)
            setDestinationFinalCopy(props.destinationFinal)
        }
    }

    const handleCancelSelectDestination = () => {
        setOpenDestinatioModalRegistred(false);

        props.setDestinationFinal(destinationFinalCopy)
    }

    useEffect(() => {
        let errorMessage = ''
        /* const destinationTimeZoneCode = props.destinationFinal?.timeZone?.code; */

        if (props.destinationFinal?.timeZone) {
            const normalizedFrom = dayjs(props.defaultValues.from).tz(localTimeZone, true);
            const normalizedTo = dayjs(props.defaultValues.to).tz(localTimeZone, true);
            if (normalizedTo.isBefore(normalizedFrom.add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
        } else {
            if (dayjs(props.defaultValues.to).isBefore(dayjs(props.defaultValues.from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') }
        }

        /* if (dayjs(props.defaultValues.to).isBefore(dayjs(props.defaultValues.from).add(5, 'minute'))) { errorMessage = t('general.validations.minimus5minute') } */

        setErrors(prev => ({
            ...prev,
            to: errorMessage
        }))
    }, [props.defaultValues])

    /* useEffect(() => {

        if (!(oldTypeDestination == DestinationType.DESTINATION && props.destinationFinal?.type == DestinationType.DESTINATION)) {

            const destinationTimeZoneCode = toUnitTimeZone(new Date(), props.destinationFinal?.timeZone?.value);

            if (props.idToEdit == 0) {
                if (props.destinationFinal?.timeZone) {
                    props.setDefaultValues({ from: dayjs(destinationTimeZoneCode), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs(destinationTimeZoneCode) })
                } else if (!props.destinationFinal?.timeZone) {
                    props.setDefaultValues({ from: dayjs(), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs() })
                }
            } else {
                if (editInEdit) {
                    if (props.destinationFinal?.timeZone) {
                        props.setDefaultValues({ from: dayjs(destinationTimeZoneCode), to: null })
                        props.handleChangeCrud({ name: 'from', date: dayjs(destinationTimeZoneCode) })
                    } else if (!props.destinationFinal?.timeZone) {
                        props.setDefaultValues({ from: dayjs(), to: null })
                        props.handleChangeCrud({ name: 'from', date: dayjs() })
                    }
                }
            }

        }

    }, [props.destinationFinal]); */

    useEffect(() => {
        const destinationTimeZoneCode = toUnitTimeZone(new Date(), props.destinationFinal?.timeZone?.value);


        if (!(oldTypeDestination == DestinationType.DESTINATION && props.destinationFinal?.type == DestinationType.DESTINATION)) {

            if (props.destinationFinal?.timeZone) {
                const isMinor = dayjs(props.defaultValues.from).isBefore(dayjs(destinationTimeZoneCode))
                if (isMinor) {
                    props.setDefaultValues({ from: dayjs(destinationTimeZoneCode).add(1, 'minute'), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs(destinationTimeZoneCode).add(1, 'minute') })
                }
            } else {
                const isMinor = dayjs(props.defaultValues.from).isBefore(dayjs())
                if (isMinor) {
                    props.setDefaultValues({ from: dayjs().add(1, 'minute'), to: null })
                    props.handleChangeCrud({ name: 'from', date: dayjs().add(1, 'minute') })
                }
            }

        }




    }, [props.destinationFinal]);


    return (
        <Box sx={styles.optionsContainer}>
            <Box sx={[styles.displayFlex, styles.containerActivity]} className="gp4">
                <Box sx={styles.displayFlex} className="gp2">
                    <Typography sx={styles.title}>{t('loogbook.titles.activity')}</Typography>
                    <DinamicForm input={Object.values(props.inputActivity)} values={props.dataActivity} onChange={props.onChangeCrud} />
                </Box>
                <Box sx={styles.displayFlex} className="gp2">
                    <Typography sx={styles.title}>{t('loogbook.titles.destinationRequired')}</Typography>
                    {!!props.destinationFinal ? (
                        <Box sx={styles.displayFlex} className="gp2">
                            <Box sx={styles.detinationContainer}>
                                <Box>
                                    <Typography className="bold">{t('general.tags.name')}</Typography>
                                    <Typography>{props.destinationFinal.name}</Typography>
                                </Box>
                                {props.destinationFinal.compnayId &&
                                    <Box>
                                        <Typography className="bold">{t('loogbook.company')}</Typography>
                                        <Typography>{props.destinationFinal.companyName}</Typography>
                                    </Box>
                                }
                                {props.destinationFinal.direction &&
                                    <Box>
                                        <Typography className="bold">{t('loogbook.direction')}</Typography>
                                        <Typography>{props.destinationFinal.direction}</Typography>
                                    </Box>
                                }
                                <Box>
                                    <Typography className="bold">{t('general.tags.latitude')}</Typography>
                                    <Typography>{props.destinationFinal.latitude}</Typography>
                                </Box>
                                <Box>
                                    <Typography className="bold">{t('general.tags.longitude')}</Typography>
                                    <Typography>{props.destinationFinal.longitude}</Typography>
                                </Box>
                            </Box>
                            <Box sx={styles.buttonWithoutBorder}>
                                <Button
                                    onClick={() => {
                                        if (props.idToEdit !== 0 && props.destinationFinal?.type === DestinationType.UNITY) {
                                            setEditInEdit(true)
                                        }
                                        if (props.destinationFinal) {
                                            props.destinationFinal.type === DestinationType.DESTINATION
                                                ?
                                                props.destinationFinal.toCreateSelected ?
                                                    handleEditDestinationSelected(false)
                                                    :
                                                    handleEditDestination(false)
                                                : handleEditUnity(false);
                                        } else {
                                        }
                                    }}
                                >
                                    {props.destinationFinal.type == DestinationType.DESTINATION ? t('loogbook.buttons.editDestination') : t('loogbook.buttons.editUnity')}
                                </Button>
                                <PopoverButtons
                                    buttonLabel={t('loogbook.buttons.change')}
                                    list={
                                        props.destinationFinal.id
                                            ? [
                                                {
                                                    action: () => handleEditDestination(true),
                                                    disable: false,
                                                    label: t('loogbook.buttons.create'),
                                                },
                                                {
                                                    action: () => handleEditDestinationSelected(true),
                                                    disable: false,
                                                    label: t('loogbook.buttons.destionationRegister'),
                                                },
                                            ]
                                            : props.destinationFinal.idDestnation && !props.destinationFinal.toCreateSelected
                                                ? [
                                                    {
                                                        action: () => handleEditUnity(true),
                                                        disable: false,
                                                        label: t('loogbook.buttons.selectUnity'),
                                                    },
                                                    {
                                                        action: () => handleEditDestinationSelected(true),
                                                        disable: false,
                                                        label: t('loogbook.buttons.selectDestination'),
                                                    },
                                                ]
                                                : [
                                                    {
                                                        action: () => handleEditUnity(true),
                                                        disable: false,
                                                        label: t('loogbook.buttons.selectUnity'),
                                                    },
                                                    {
                                                        action: () => handleEditDestination(true),
                                                        disable: false,
                                                        label: t('loogbook.buttons.createDestination'),
                                                    },
                                                ]
                                    }
                                    styleType
                                />
                                {/* <Button
                                    onClick={() => {
                                        setEditInEdit(true)
                                        if (props.destinationFinal) {
                                            props.destinationFinal.type === DestinationType.UNITY
                                                ? handleEditDestination(true)
                                                : handleEditUnity()
                                        } else {
                                        }
                                    }}
                                >{props.destinationFinal.type == DestinationType.DESTINATION ? t('loogbook.buttons.selectUnity') : t('loogbook.buttons.createDestination')}</Button> */}
                            </Box>
                        </Box>
                    ) : (
                        <Box sx={styles.conteinerButton}>
                            <Button onClick={() => { handleEditUnity(true) }}>{t('loogbook.buttons.selectUnity')}</Button>
                            {/* <Button onClick={() => { handleEditDestination(true) }}>{t('loogbook.buttons.createDestination')}</Button> */}
                            <PopoverButtons
                                buttonLabel={t('loogbook.buttons.destionation')}
                                list={[
                                    { action: () => handleEditDestination(true), disable: false, label: t('loogbook.buttons.create') },
                                    { action: () => handleEditDestinationSelected(true), disable: false, label: t('loogbook.buttons.destionationRegister') }
                                ]}
                                styleType
                            />
                        </Box>
                    )}
                </Box>
                <Box sx={styles.displayFlex} className="gp2">
                    <Typography sx={styles.title}>{t('loogbook.titles.programming')}</Typography>
                    <DinamicForm input={Object.values(props.inputActivityCheck)} values={props.dataActivity} onChange={props.onChangeCrud} />
                    {!props.dataActivity?.free &&
                        <Box sx={styles.containerDate}>
                            <DateModalSimple
                                timeZone={props?.destinationFinal?.timeZone?.code ?? localTimeZone}
                                setIsToBiggerThanFrom={props.setIsToBiggerThanFrom}
                                buttonTitle="Desde *"
                                defaultDate={props.defaultValues.from}
                                errorMsg={errors?.from}
                                error={!!(errors.from)}
                                getDate={(date) => { props.getDate(date, 'from') }}
                                payload={{ max: props.defaultValues.to, min: props.destinationFinal?.timeZone ? dayjs(toUnitTimeZone(new Date(), props.destinationFinal?.timeZone?.value)) : dayjs(), is: { start: true, startLower: props.isToBiggerThanFrom } }}
                                title='SELECCIÓN DE FECHA DE INICIO' name="from"
                            />

                            <DateModalSimple
                                timeZone={props?.destinationFinal?.timeZone?.code ?? localTimeZone}
                                setIsToBiggerThanFrom={props.setIsToBiggerThanFrom}
                                buttonTitle="Hasta *"
                                defaultDate={props.defaultValues.to}
                                errorMsg={errors?.to}
                                error={!!(errors.to)}
                                getDate={(date) => { props.getDate(date, 'to') }}
                                /* payload={{ min: props.defaultValues.from ?? dayjs(), is: { end: true, endBigger: props.isToBiggerThanFrom } }} */
                                payload={{ min: dayjs(props.defaultValues.from).tz(localTimeZone, true) ?? dayjs(), is: { end: true, endBigger: props.isToBiggerThanFrom } }}
                                title='SELECCIÓN DE FECHA DE FIN' name="to" />
                        </Box>
                    }
                </Box>

                <Button disabled={disableActivityForm || !props.destinationFinal || (!props.dataActivity?.free && !props.defaultValues.to) || (!props.dataActivity?.free && !!(errors.to))} onClick={props.idToEdit == 0 ? handleAddActivity : handleEditActivity} variant="contained">{props.idToEdit == 0 ? t('general.add') : t('general.edit')}</Button>

                <InputModal
                    open={openUnityModal}
                    title={t('stores.filter.inputs.search')}
                    cancelText={t('general.cancel')}
                    buttonText={t('loogbook.buttons.select')}
                    disableButton={!props.destination}
                    back={handleCancelUnity}
                    next={handleCloseUnity}
                    children={<>
                        <Box sx={styles.filters}>
                            {!!props.filterUnity.counter && (<CustomeIconButton icon={icons('clean')} title={t('ToolTips.clearFilters')} iconButtonProps={{ sx: styles.cleanFilters, onClick: () => { props.filterUnity.cleanFilter() } }} />)}
                            <DinamicForm input={Object.values(props.inputFilterUnity)} values={props.filterUnity.filterData} onChange={props.filterUnity.onChange} />
                        </Box>

                        <Box sx={styles.table({ row: !!props.tableUnits.row.length })}>
                            <CustomTable
                                name={'Table'}
                                dontRefresh
                                column={props.tableUnits.column}
                                onClick={(e) => { props.handleRowClickUnity(e.checks[0]); }}
                                defaultChecks={[Number(props.destination?.id)]}
                                tableRadio
                                tableChecks
                                row={props.tableUnits.row}
                                selected={-1}
                                loader={props.loading.units}
                                serverSidePagination={{ page: props.filterUnity.paginationModel.page + 1, size: props.filterUnity.paginationModel.pageSize, totalPages: props.totalPages }}
                                handleChange={(page: number, pageSize: number) => {
                                    props.filterUnity.handlePagination({ page, pageSize })
                                }}
                            />
                        </Box>
                    </>}
                />

                <InputModal
                    open={openDestinatioModal}
                    title={undefined}
                    cancelText={t('general.cancel')}
                    buttonText={(props.destinationFinal?.type == DestinationType.DESTINATION && !props.destinationFinal.toCreateSelected) ? t('loogbook.titles.editDestination') : t('loogbook.titles.createDestination')}
                    back={closeModal}
                    next={() => { handleSetDestination({ edit: props.destinationFinal?.type == DestinationType.DESTINATION }) }}
                    disableButton={(!company.company && !value.company && company.role == Roles.ADMIN) || value.direction.trim()?.length < 3 || value.name.trim()?.length < 3 || !props.selectedPoint}
                    sx={styles.mapModal}
                    hideClose
                    children={
                        <Box sx={styles.map}>
                            <MapActivity
                                defaultCenter={{ lat: props.selectedPoint ? props.selectedPoint.lat : 37.7749, lng: props.selectedPoint ? props.selectedPoint.lng : -122.4194 }}
                                defaultZoom={14}
                                selectedPoint={props.selectedPoint}
                                onMapClick={handleMapClick}
                                onPlaceSelect={handlePlaceSelect}
                                value={value}
                                setValue={setValue}
                                compnayId={company.company?.id}
                                role={company.role}
                                companies={props.companies}
                                title={props.destinationFinal?.type == DestinationType.DESTINATION ? t('loogbook.titles.editDestination') : t('loogbook.titles.createDestination')}
                            />
                        </Box>
                    }
                />

                <InputModal
                    open={openDestinatioModalRegitred}
                    title={undefined}
                    cancelText={undefined}
                    buttonText={undefined}
                    back={() => { }}
                    next={() => { }}
                    disableButton={undefined}
                    sx={styles.mapModal}
                    hideClose
                    hiddenFooterButton
                    children={
                        <Box sx={styles.map}>
                            <DestinationModal
                                cancel={handleCancelSelectDestination}
                                confirm={handleSetDestinationSelected}
                                destinations={allDestionatiosList}
                                destinationSelected={
                                    props.destinationFinal ? {
                                        latitude: props.destinationFinal.latitude,
                                        longitude: props.destinationFinal.longitude,
                                        id: props.destinationFinal.idDestnation,
                                        direction: props.destinationFinal.direction ?? '',
                                        name: props.destinationFinal.name
                                    } : null
                                }
                            />
                        </Box>
                    }
                />

                <SimpleModal
                    open={openSimple.open}
                    close={() => { closeSimpleModal() }}
                    removeClose
                    title={openSimple.title}
                    description={openSimple.description}
                    buttonText={t('general.confirm')}
                    cancelText={t('general.cancel')}
                    back={openSimple?.cancel ?? undefined}
                    next={openSimple.confirm ?? closeSimpleModal}
                />

                <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
            </Box>
        </Box>
    )
}